import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import Global from '../../../store/global-selectors';
import { labelQueGetWarningAndErrorRequest, collapseErrorOrWarning, retryBatch } from '../../../store/label-que/label-que.actions';
import TileFooterErrorOrWarning from '../components/label-que-batch-tile/components/tile-footer-error-or-warning';
import { goToOrderDetails } from '../../../store/orders/order-details/orders.details.actions';
import { emptyArray } from 'ui-components/default-props/empty';

const errorsOrWarningsSelector = createSelector(
  (errWarnItems) => errWarnItems,
  (errWarnItems) => errWarnItems.filter((errOrWarn) => errOrWarn.statusId === 'Error' || errOrWarn.isWarning),
);

const mapStateToProps = (state, ownProps) => {
  const { batchId } = ownProps;
  const errorsOrWarnings = Global.selectLabelQueWarnOrErrorByBatchId(state, {
    batchId,
  });
  if (!errorsOrWarnings) {
    return {
      isLoading: false,
      errorsOrWarnings: emptyArray,
      isExpanded: false,
    };
  }

  const { isLoading, isExpanded, items = emptyArray } = errorsOrWarnings;
  return {
    isLoading,
    isExpanded,
    errorsOrWarnings: errorsOrWarningsSelector(items),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetErrorOrWarning: () => {
    dispatch(labelQueGetWarningAndErrorRequest(ownProps.batchId));
  },
  openFulfillmentPlanDetailsById: (salesOrderId, fulfillmentPlanId) => {
    dispatch(
      goToOrderDetails({
        salesOrderId,
        fulfillmentPlanId,
      }),
    );
  },
  onCollapseErrorOrWarning: () => {
    dispatch(collapseErrorOrWarning(ownProps.batchId));
  },
  onRetryBatch: () => {
    dispatch(retryBatch(ownProps.batchId));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TileFooterErrorOrWarning);
